import * as React from 'react'
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import './OnlineJourney.css'
import {
    PRODUCT_COMPREHENSIVE_CAR, PRODUCT_BLING, PRODUCT_CAR_WARRANTY, PRODUCT_PORTABLE_POSSESSIONS, NEW_QUOTE_CAR, PRODUCT_CODE_RED, PRODUCT_BUILDING, PRODUCT_HOME_CONTENT,
} from '../../constants/constants';
import { SA_COUNTRY_ID_NUMBER } from '../../constants/internationalization';

import { showCallMeModal, showComingSoon } from '../../actions/modalActions';
import { addProduct, setQuoteType } from './../../actions/salesActions';
import { logEvent } from '../../firebase/firebase';

class OnlineJourneySelect extends React.Component<any, any> {

    addProduct(product) {
        logEvent('SSP_add_product_selection', product);
        if ((this.props.profile.countryId === 157 && this.props.profile.policyId === "" && product !== PRODUCT_COMPREHENSIVE_CAR)) {
            this.props.handleCallMeBack();
        } else if ((product === PRODUCT_BLING)) {
            this.props.dispatchSetQuoteType(product);
            this.props.dispatchAddProduct(product);
        } else if ((product === PRODUCT_CODE_RED)) {
            this.props.dispatchSetQuoteType(product);
            this.props.dispatchAddProduct(product);
        }
        else {
            this.props.dispatchSetQuoteType(product);
            this.props.dispatchAddProduct(product);
        }
    }

    render() {
        let hasCar = false;
        if (this.props.cart.products != undefined && this.props.cart.products.length > 0) {
            hasCar = this.props.cart.products.filter(x => (x.name.toLowerCase() === 'car' || x.name.toLowerCase() === 'motorbike' || x.name.toLowerCase() === 'building' || x.name.toLowerCase() === 'home contents' || x.name.toLowerCase().includes('chilli') /*|| x.name.toLowerCase().includes('bling')*/)).length > 0;
        }
        let hasPolicyMainline = false;
        if (this.props.profile.personalPolicies[0] !== undefined) {
            if (this.props.profile.personalPolicies[0].covers.length > 0) {
                hasPolicyMainline = this.props.profile.personalPolicies[0].covers.filter(x => hasPolicyMainline = this.props.profile.personalPolicies[0].covers.filter(x => (x.productName.toLowerCase() === 'car' || x.productName.toLowerCase() === 'motorbike' || x.productName.toLowerCase() === 'building' || x.productName.toLowerCase() === 'home contents' || x.productName.toLowerCase().includes('chilli'))).length > 0).length > 0
            }
        }
        let hasCodeRed = false;
        if (this.props.profile.personalPolicies[0] !== undefined) {
            if (this.props.profile.personalPolicies[0].covers.length > 0) {
                hasCodeRed = (this.props.profile.personalPolicies[0].covers.filter(x => (x.productName.toLowerCase() === 'code red')).length > 0)
                if (!hasCodeRed && this.props.cart.products != undefined && this.props.cart.products.length > 0) {
                    hasCodeRed = this.props.cart.products.filter(x => (x.name.toLowerCase() === 'code red')).length > 0;
                }
            }
        }
        else if (this.props.cart.products != undefined && this.props.cart.products.length > 0) {
            hasCodeRed = this.props.cart.products.filter(x => (x.name.toLowerCase() === 'code red')).length > 0;
        }

        return (
            <>
                <div className="addcover-new-content-holder">
                    <div className="addcover-header-dashboard">
                        <p className="addcover-lets-get-you-covered">Let's get you covered</p>
                        <h2 className="addcover-dashboard-get-prices">Get prices</h2>
                    </div>
                    <div className="addcover-header-modal">
                        <p className="Lets-get-you-covered mt-20px mb-10px">Add cover</p>
                        <h2 className="Get-prices">Choose a product to get started</h2>
                    </div>

                    <div id="Addcover">
                        <div className="row noma">
                            <div className="col-12 col-lg-12 col-md-12 nopa">
                                <a className="text-decoration-none cursor-pointer" id="add-product-car" onClick={() => this.addProduct(PRODUCT_COMPREHENSIVE_CAR)}>
                                    <div className="row align-items-center addcover-item-container no-gutters">
                                        <div className="addcover-image-col">
                                            <Image src="./Images/OnlineQuotes/icon-addcover-car-insurance.svg" alt='Car Insurance' title='Car Insurance' className="add-cover-image" />
                                        </div>
                                        <div className="col addcover-text-col">
                                            <p className="Car my-auto">Car insurance</p>
                                        </div>
                                        <div className="text-right addcover-plus-col">
                                            <div className="addcover-plus-img" title="Add Cover"></div>
                                        </div>
                                    </div>
                                </a>
                                <hr />
                            </div>
                            {(hasPolicyMainline || hasCar) && this.props.profile.countryId === 244 &&
                                <div className="col-12 col-lg-12 col-md-12 nopa">
                                    <a className="text-decoration-none cursor-pointer" id="add-product-portable" onClick={() => this.addProduct(PRODUCT_PORTABLE_POSSESSIONS)}>
                                        <div className="row align-items-center addcover-item-container no-gutters">
                                            <div className="addcover-image-col">
                                                <Image src="./Images/OnlineQuotes/icon-addcover-portable-possessions.svg" alt='Portable possessions insurance' title='Portable possessions insurance' className="add-cover-image" />
                                            </div>
                                            <div className="col addcover-text-col">
                                                <p className="Car my-auto">Portable possessions insurance</p>
                                            </div>
                                            <div className="text-right addcover-plus-col">
                                                <div className="addcover-plus-img" title="Add Cover"></div>
                                            </div>
                                        </div>
                                    </a>
                                    <hr />
                                </div>
                            }
                            {this.props.profile.countryId === 244 &&
                                <div className="col-12 col-lg-12 col-md-12 nopa">
                                    <a className="text-decoration-none cursor-pointer" id="add-product-warranty" onClick={() => this.addProduct(PRODUCT_CAR_WARRANTY)}>
                                        <div className="row align-items-center addcover-item-container no-gutters mb-3">
                                            <div className="addcover-image-col">
                                                <Image src="./Images/OnlineQuotes/icon-addcover-car-warranty-insurance.svg" alt='Car warranty cover' title='Car warranty cover' className="add-cover-image" />
                                            </div>
                                            <div className="col addcover-text-col">
                                                <p className="Car my-auto">Car warranty insurance</p>
                                            </div>
                                            <div className="text-right addcover-plus-col">
                                                <div className="addcover-plus-img" title="Add Cover"></div>
                                            </div>
                                        </div>
                                    </a>
                                    <hr />
                                </div>
                            }

                            {this.props.ssp.codeRedEnabled && !hasCodeRed && this.props.profile.countryId === 244 &&
                                <div className="col-12 col-lg-12 col-md-12 nopa">
                                    <a className="text-decoration-none cursor-pointer" id="add-product-code-red" onClick={() => this.addProduct(PRODUCT_CODE_RED)}>
                                        <div className="row align-items-center addcover-item-container no-gutters mb-3">
                                            <div className="addcover-image-col">
                                            <Image src="./Images/OnlineQuotes/icon-addcover-code red.svg" alt='Code red' title='Code red' className="add-cover-image" />
                                            </div>
                                            <div className="col addcover-text-col">
                                                <p className="Car my-auto">Code red</p>
                                            </div>
                                            <div className="text-right addcover-plus-col">
                                                <div className="addcover-plus-img" title="Add Cover"></div>
                                            </div>
                                        </div>
                                    </a>
                                    <hr />
                                </div>
                            }

                            {this.props.ssp.salesBuildingAndContentEnabled && this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                <>
                                    <div className="col-12 nopa">
                                        <a className="text-decoration-none cursor-pointer" id="add-product-home-content" onClick={() => this.addProduct(PRODUCT_HOME_CONTENT)}>
                                            <div className="row align-items-center addcover-item-container no-gutters mb-3">
                                                <div className="addcover-image-col">
                                                    <Image src="./Images/OnlineQuotes/icon-addcover-home-content-insurance.svg" alt='Home contents insurance' title='Home contents insurance' className="add-cover-image" />
                                                </div>
                                                <div className="col addcover-text-col">
                                                    <p className="Car my-auto">Home contents insurance</p>
                                                </div>
                                                <div className="text-right addcover-plus-col">
                                                    <div className="addcover-plus-img" title="Add Cover"></div>
                                                </div>
                                            </div>
                                        </a>
                                        <hr />
                                    </div>

                                    <div className="col-12 nopa">
                                        <a className="text-decoration-none cursor-pointer" id="add-product-building" onClick={() => this.addProduct(PRODUCT_BUILDING)}>
                                            <div className="row align-items-center addcover-item-container no-gutters mb-3">
                                                <div className="addcover-image-col">
                                                    <Image src="./Images/OnlineQuotes/icon-addcover-building-insurance.svg" alt='Building insurance' title='Building insurance' className="add-cover-image" />
                                                </div>
                                                <div className="col addcover-text-col">
                                                    <p className="Car my-auto">Building insurance</p>
                                                </div>
                                                <div className="text-right addcover-plus-col">
                                                    <div className="addcover-plus-img" title="Add Cover"></div>
                                                </div>
                                            </div>
                                        </a>
                                        <hr />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
        profile: state.profile,
        cart: state.cart,
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAddProduct: (action) => dispatch(addProduct(action)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        handleShowComingSoon: () => dispatch(showComingSoon()),
        dispatchSetQuoteType: (product) => dispatch(setQuoteType(product)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineJourneySelect);